// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.endGame-container {
  /* display: block; */
  padding: 0px;
  transition: 150ms padding, 150ms box-shadow;
}

.endGame-container.expanded {
  box-shadow: 0 0 10px #aaa;
  border-radius: 5px;
  padding: 10px 5px;
}

.endGame-end {
  padding-left: 0;
  padding-right: 0;
}

.endGame-cancel {
  margin-right: 30px;
}


#nalavo-chooseRoles-block {
  margin-bottom: 20px;
}

#nalavo-chooseRoles-block .nalavo-roles-box {
  margin-top: 10px;

  padding: 10px 10px 15px 10px;
  /* background-color: #eee; */
  /* box-shadow: 0 0 5px #ccc; */
}

#nalavo-waitingFor-block div {
  margin-left: 20px;
  display: inline-block;
}


#nalavo-chooseRoles-block h1 {
  margin-bottom: 10px;
  font-weight: 300;
}

#nalavo-chooseRoles-block h2 {
  font-weight: 500;
  color: #808080;
  margin-top: 5px;
  margin-bottom: 5px;
}

#nalavo-view {
  height: 100%;
  overflow: auto;
}



#nalavo-view .nalavo-action-instructions {
  text-align: center;
  margin: 10px 0px;
}

#nalavo-view .nalavo-action-buttons {
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
}


.nalavo-gameStatus-block {
  display: flex;
  flex-wrap: wrap;
}

.nalavo-gameStatus-playerList {
  flex-shrink: 0;
  margin-right: 40px;
  margin-bottom: 20px;

}

.nalavo-gameStatus-intelBox {
  text-align: center;
  flex: 15rem 1 0;
}


.nalavo-gameStatus-intelBox .nalavo-intel-roleLabel {
  font-size: 1.6rem;
  margin-bottom: 0.6rem;

}

.nalavo-gameStatus-block ol {
  margin: 0; /* Override default 1em top/bottom margin*/
  padding: 0px; /* Remove left indent to make it line up */
  list-style-position: inside; /* Line up the number, instead of the text*/
}


.nalavo-gameStatus-block span.nalavo-gameStatus-builderLabel {
  border-radius: 1000px;
  font-style: italic;
  color: #808080;
}

#nalavo-missionsList-block label {
  text-align: center;
}

#nalavo-missionsList-block .nalavo-missionsList-mission {
  margin: 20px 0px;
  border: 2px solid #eee;
}
#nalavo-missionsList-block .nalavo-missionsList-missionHeader {
  position: relative; /*For inner icon to have position:absolute*/
  z-index: -1;
  display: flex;
  justify-content: space-around;

  color: white;
}

#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-succeeded
.nalavo-missionsList-missionHeader {
  background-color: #696;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-failed
.nalavo-missionsList-missionHeader {
  background-color: #966;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-active
.nalavo-missionsList-missionHeader {
  background-color: #06c;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-pending
.nalavo-missionsList-missionHeader {
  background-color: #ccc;
  color: #555;
}

#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-succeeded {
  border: 2px solid #696;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-failed {
  border: 2px solid #966;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-active {
  border: 2px solid #06c;
}
#nalavo-missionsList-block
.nalavo-missionsList-mission.nalavo-missionsList-mission-pending {
  border: 2px solid #ccc;
}



#nalavo-missionsList-block .nalavo-missionsList-missionHeader div {
  text-align: center;
  flex-basis: 50%;
  margin: 10px 20px;
}

#nalavo-missionsList-block .nalavo-missionsList-missionHeader i {
  position: absolute;
  left: 0;
  margin: 10px;
}



#nalavo-missionsList-block .nalavo-missionsList-roundInfo {
  background-color: #f2f2f2;
  overflow: auto; /* Prevent margin collapse */
  text-align: center;
  margin: 10px;
}
#nalavo-missionsList-block .nalavo-missionsList-roundInfo>div {
  margin: 20px 10px;
}

#nalavo-missionsList-block .nalavo-missionsList-votes {
  display: flex;
}
#nalavo-missionsList-block .nalavo-missionsList-votes>div {
  /*Approvers or Rejectors*/
  width: 50%;
  margin: 10px;
}

#nalavo-missionsList-block .nalavo-missionsList-success {
  text-align: center;
  color: #008800;
}
#nalavo-missionsList-block .nalavo-missionsList-fail {
  text-align: center;
  color: #bb0000;
}
#nalavo-missionsList-block .nalavo-missionsList-skipped {
  text-align: center;
  color: #bb8811;
}
#nalavo-missionsList-block .nalavo-missionsList-pending {
  text-align: center;
  color: #444;
}


#nalavo-gameOver-block {
  /* padding: 10px; */
  text-align: center;
  font-size: 2rem;
  padding: 2rem;
}


.nalavo-roleDescriptor {
  display: flex;
  margin: 20px 0;
}

.nalavo-roleDescriptor-text {

}

.nalavo-roleDescriptor-roleName {
  font-size: 1.4rem;
}
.nalavo-roleDescriptor-description {

}

.nalavo-roleDescriptor-icon {
  height: 3rem;
  margin-right: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/style/nalavo.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;;;AAIA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,iBAAiB;EACjB,qBAAqB;;AAEvB;;AAEA;EACE,SAAS,EAAE,0CAA0C;EACrD,YAAY,EAAE,0CAA0C;EACxD,2BAA2B,EAAE,2CAA2C;AAC1E;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,WAAW;EACX,aAAa;EACb,6BAA6B;;EAE7B,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;;;;AAIA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;;;AAIA;EACE,yBAAyB;EACzB,cAAc,EAAE,4BAA4B;EAC5C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;AAEA;;AAEA;EACE,iBAAiB;AACnB;AACA;;AAEA;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["\n.endGame-container {\n  /* display: block; */\n  padding: 0px;\n  transition: 150ms padding, 150ms box-shadow;\n}\n\n.endGame-container.expanded {\n  box-shadow: 0 0 10px #aaa;\n  border-radius: 5px;\n  padding: 10px 5px;\n}\n\n.endGame-end {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.endGame-cancel {\n  margin-right: 30px;\n}\n\n\n#nalavo-chooseRoles-block {\n  margin-bottom: 20px;\n}\n\n#nalavo-chooseRoles-block .nalavo-roles-box {\n  margin-top: 10px;\n\n  padding: 10px 10px 15px 10px;\n  /* background-color: #eee; */\n  /* box-shadow: 0 0 5px #ccc; */\n}\n\n#nalavo-waitingFor-block div {\n  margin-left: 20px;\n  display: inline-block;\n}\n\n\n#nalavo-chooseRoles-block h1 {\n  margin-bottom: 10px;\n  font-weight: 300;\n}\n\n#nalavo-chooseRoles-block h2 {\n  font-weight: 500;\n  color: #808080;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n#nalavo-view {\n  height: 100%;\n  overflow: auto;\n}\n\n\n\n#nalavo-view .nalavo-action-instructions {\n  text-align: center;\n  margin: 10px 0px;\n}\n\n#nalavo-view .nalavo-action-buttons {\n  padding: 10px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n\n.nalavo-gameStatus-block {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.nalavo-gameStatus-playerList {\n  flex-shrink: 0;\n  margin-right: 40px;\n  margin-bottom: 20px;\n\n}\n\n.nalavo-gameStatus-intelBox {\n  text-align: center;\n  flex: 15rem 1 0;\n}\n\n\n.nalavo-gameStatus-intelBox .nalavo-intel-roleLabel {\n  font-size: 1.6rem;\n  margin-bottom: 0.6rem;\n\n}\n\n.nalavo-gameStatus-block ol {\n  margin: 0; /* Override default 1em top/bottom margin*/\n  padding: 0px; /* Remove left indent to make it line up */\n  list-style-position: inside; /* Line up the number, instead of the text*/\n}\n\n\n.nalavo-gameStatus-block span.nalavo-gameStatus-builderLabel {\n  border-radius: 1000px;\n  font-style: italic;\n  color: #808080;\n}\n\n#nalavo-missionsList-block label {\n  text-align: center;\n}\n\n#nalavo-missionsList-block .nalavo-missionsList-mission {\n  margin: 20px 0px;\n  border: 2px solid #eee;\n}\n#nalavo-missionsList-block .nalavo-missionsList-missionHeader {\n  position: relative; /*For inner icon to have position:absolute*/\n  z-index: -1;\n  display: flex;\n  justify-content: space-around;\n\n  color: white;\n}\n\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-succeeded\n.nalavo-missionsList-missionHeader {\n  background-color: #696;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-failed\n.nalavo-missionsList-missionHeader {\n  background-color: #966;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-active\n.nalavo-missionsList-missionHeader {\n  background-color: #06c;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-pending\n.nalavo-missionsList-missionHeader {\n  background-color: #ccc;\n  color: #555;\n}\n\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-succeeded {\n  border: 2px solid #696;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-failed {\n  border: 2px solid #966;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-active {\n  border: 2px solid #06c;\n}\n#nalavo-missionsList-block\n.nalavo-missionsList-mission.nalavo-missionsList-mission-pending {\n  border: 2px solid #ccc;\n}\n\n\n\n#nalavo-missionsList-block .nalavo-missionsList-missionHeader div {\n  text-align: center;\n  flex-basis: 50%;\n  margin: 10px 20px;\n}\n\n#nalavo-missionsList-block .nalavo-missionsList-missionHeader i {\n  position: absolute;\n  left: 0;\n  margin: 10px;\n}\n\n\n\n#nalavo-missionsList-block .nalavo-missionsList-roundInfo {\n  background-color: #f2f2f2;\n  overflow: auto; /* Prevent margin collapse */\n  text-align: center;\n  margin: 10px;\n}\n#nalavo-missionsList-block .nalavo-missionsList-roundInfo>div {\n  margin: 20px 10px;\n}\n\n#nalavo-missionsList-block .nalavo-missionsList-votes {\n  display: flex;\n}\n#nalavo-missionsList-block .nalavo-missionsList-votes>div {\n  /*Approvers or Rejectors*/\n  width: 50%;\n  margin: 10px;\n}\n\n#nalavo-missionsList-block .nalavo-missionsList-success {\n  text-align: center;\n  color: #008800;\n}\n#nalavo-missionsList-block .nalavo-missionsList-fail {\n  text-align: center;\n  color: #bb0000;\n}\n#nalavo-missionsList-block .nalavo-missionsList-skipped {\n  text-align: center;\n  color: #bb8811;\n}\n#nalavo-missionsList-block .nalavo-missionsList-pending {\n  text-align: center;\n  color: #444;\n}\n\n\n#nalavo-gameOver-block {\n  /* padding: 10px; */\n  text-align: center;\n  font-size: 2rem;\n  padding: 2rem;\n}\n\n\n.nalavo-roleDescriptor {\n  display: flex;\n  margin: 20px 0;\n}\n\n.nalavo-roleDescriptor-text {\n\n}\n\n.nalavo-roleDescriptor-roleName {\n  font-size: 1.4rem;\n}\n.nalavo-roleDescriptor-description {\n\n}\n\n.nalavo-roleDescriptor-icon {\n  height: 3rem;\n  margin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
